// extracted by mini-css-extract-plugin
module.exports = {"button":"ItemActions-button-34ea","space":"ItemActions-space-34ea"};